export default __webpack_public_path__ + "static/media/Onson Sweemey.99a96683.jpg";